export default function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-motion/node_modules/rc-util/es/Dom/canUseDom.js
// module id = 282
// module chunks = 0